
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_5a145_xnmua_7",
  "inline-container": "awsui_inline-container_5a145_xnmua_11",
  "inline-container-trigger": "awsui_inline-container-trigger_5a145_xnmua_14",
  "inline-container-no-wrap": "awsui_inline-container-no-wrap_5a145_xnmua_17",
  "text-to-display": "awsui_text-to-display_5a145_xnmua_26"
};
  